export const shortplayFormConfig = {
    businessPoint: {
        label: '推广业务',
        tip: '推广业务是您提供的最细粒度的产品或服务，例如语言培训客户，业务可能有“雅思培训”托福培训”“少儿英语”等；如果没有合适的，也支持您自定义输入',
        placeholder: '请输入你的业务点',
        maxlength: 50
    },
    description: {
        label: '产品信息',
        placeholder: '请填写输入卖点/品牌名称/产品描述/广告语/前3s台词，例如：小度音响，集合了3D环绕的优点，可以链接蓝牙，与家庭设备互动，买一赠一',
        maxlength: 500,
        rows: 4
    },
    roleDesc: {
        label: '角色设定',
        tip: '需要自定义剧本中出现的角色时可填写，可包括人数、角色特征（性别、年龄、服饰、神态等）；为保障生成文案的有效性，请注意填写角色体与产品服务的匹配状况',
        placeholder: '示例：2个上班族，30岁左右，商务休闲装',
        maxlength: 500,
        rows: 4
    },
    additionalInfo: {
        label: '附加说明',
        placeholder: '示例：明亮而简洁的咖啡厅，年轻老板正坐在窗边的位置上，手边放着一杯咖啡和一台笔记本电脑，正忙于查看财务报表',
        maxlength: 500,
        rows: 4
    },
    duration: {
        label: '时长',
        tip: '可设置期望口播视频时长，时长将会影响文案长度',
        placeholder: '请输入',
        min: 5,
        max: 180
    },
    targetCount: {
        tip: 'AI将会尽量生产足够数量的文案，由于生成文案需要进行审核、质量保障等过滤，偶尔可能会出现少于预期个数的情况，对此您可以尝试多次生成。',
        options: [
            {label: '1', value: '1'},
            {label: '2', value: '2'},
            {label: '3', value: '3'},
            {label: '4', value: '4'},
            {label: '5', value: '5'}
        ]
    },
    editMaxlength: 2000
};
